import { render, staticRenderFns } from "./RatingFormItem.vue?vue&type=template&id=16000864&scoped=true&"
import script from "./RatingFormItem.vue?vue&type=script&lang=js&"
export * from "./RatingFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16000864",
  null
  
)

export default component.exports